import { node } from "prop-types";
import { useContext } from "react";

import styled from "styled-components";

import { FnrAccordionContext } from "./FnrAccordion";

const SizeMaintainer = styled("div")`
  ${({ $cardIsShowing }) => {
    return $cardIsShowing ? "margin: 0 0px;" : "margin: 0 8px;";
  }}
  overflow-y: hidden;
  transition: margin 0.3s;
`;

/** Keeps size of container the same as the card comes in. Only applied if addCard is true */
const SizeMaintainerRelay = ({ children }) => {
  const { addCard, cardIsShowing } = useContext(FnrAccordionContext);

  if (addCard)
    return (
      <SizeMaintainer $cardIsShowing={cardIsShowing}>{children}</SizeMaintainer>
    );
  return children;
};

SizeMaintainerRelay.propTypes = { children: node };

export default SizeMaintainerRelay;
